import { useState } from "react";
import { IconShieldExclamation, IconSend } from "@tabler/icons-react";
import ModalShell from "./ModalShell";
import styles from "./SupportModal.module.css";
import Button from "../UI/Button/button";
import Input, { Select, Textarea } from "../UI/FormInput/input";
import { postSupportComplaint } from "../../services/clientCalls";
import { errorHandler } from "../../utils";

const CATEGORIES = [
  "Harassment or abuse",
  "Fake profile or impersonation",
  "Spam or scam",
  "Inappropriate content",
  "Discrimination",
  "Other",
];

const EMPTY = {
  supportType: "ReportBehavior",
  fullName: "",
  email: "",
  reportedUser: "",
  summaryOfReport: "",
  message: "",
};

export default function ReportModal({ open, onClose, setToast }) {
  const [form, setForm] = useState(EMPTY);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleClose = () => {
    setForm(EMPTY);
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const payload = {
        supportType: "ReportBehavior",
        fullName: form.fullName,
        email: form.email,
        reportedUser: form.reportedUser,
        summaryOfReport: form.summaryOfReport,
        message: form.message,
      };
      const res = await postSupportComplaint(payload);
      if (res?.data?.success) {
        handleClose();
        setToast({
          visible: true,
          message: "Report submitted. Our team will review it within 24 hours.",
        });
      }
    } catch (error) {
      error?.response?.data
        ? errorHandler(error?.response?.data?.errors, "Error")
        : errorHandler(
            "Network error: Something went wrong, Please check your internet connection and try again.",
            "Error",
          );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      icon={IconShieldExclamation}
      color="red"
      title="Report Behaviour"
      subtitle="Our trust & safety team will review this"
      footer={
        <>
          <Button variant="ghost" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className="!bg-[#dc2626]"
            leftIcon={<IconSend size={14} />}
            onClick={handleSubmit}
            disabled={isSubmitting}
            loading={isSubmitting}
          >
            Submit Report
          </Button>
        </>
      }
    >
      <div className={styles.row2}>
        <Input
          label="Your Name"
          required
          id="report-name"
          placeholder="Full name"
          value={form.fullName}
          onChange={set("fullName")}
        />
        <Input
          label="Email"
          required
          id="report-email"
          type="email"
          placeholder="you@company.com"
          value={form.email}
          onChange={set("email")}
        />
      </div>

      <Input
        label="User Being Reported"
        required
        id="report-user"
        placeholder="Username or email of the person"
        value={form.reportedUser}
        onChange={set("reportedUser")}
      />

      <Select
        label="Type of Concern"
        required
        id="report-category"
        value={form.summaryOfReport}
        onChange={set("summaryOfReport")}
      >
        <option value="" disabled>
          Select a category…
        </option>
        {CATEGORIES.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </Select>

      <Textarea
        label="Details"
        required
        id="report-details"
        placeholder="Please describe what happened, including dates and any relevant context…"
        value={form.message}
        onChange={set("message")}
      />
    </ModalShell>
  );
}
